import React from "react";
import { Restricted, permissions } from "components/auth";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import ValidatedForm from "components/form";
import LiveStreamForm from "./livestream-form";
import { getPartialValidationLivestreams } from "../../utils";
import { useCurrentCustomerContext } from "components/current-customer-context";
import DataGrid from "components/data-grid";
import { ActionWithModal } from "components/buttons";
import { addLivestreamMutation } from "./partial";
import { withRouter } from "react-router-dom";

export const handleSubmit = ({
  addEventLivestream,
  handleClose,
  history,
  eventId,
  customerId,
  onSuccess,
  onError,
}) => values => {
  const {isNew, ...liveStreamInput} = values
  const updatedData = addEventLivestream({
    variables: {
      liveStreamInput,
      eventId,
      customerId,
    },
  });

  return updatedData
    .then(result => {
      const event = result.data.addLivestream;
      if (event && event.id) {
        onSuccess();
      } else {
        onError();
      }
    })
    .catch(error => onError())
    .finally(() => handleClose());
};

const LivestreamModalForm = ({ eventId, history, onSuccess, onError, intl, handleOpen, handleClose }) => {
  const [addEventLivestream] = useMutation(addLivestreamMutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  return (
    <ValidatedForm
      onCancel={handleClose}
      initialValues={{
        rtmpUrl: "",
        key: "",
        publishingUrl: "",
        type: "",
        isNew: true
      }}
      validationSchema={getPartialValidationLivestreams({ intl })}
      onSubmit={handleSubmit({
        addEventLivestream,
        history,
        eventId,
        customerId: currentCustomerId,
        onSuccess,
        onError,
        handleClose,
      })}
    >
      {({ values, ...props }) => <LiveStreamForm showInCard={false} liveStream={values} {...props} />}
    </ValidatedForm>
  );
};

LivestreamModalForm.propTypes = {
  /**
   * Id del evento
   **/
  eventId: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object,
  /**
   * Callback de éxito
   **/
  onSuccess: PropTypes.func,
  /**
   * Callback de error
   **/
  onError: PropTypes.func,
  /**
   * Callback de apertura de modal
   **/
  handleOpen: PropTypes.func,
  /**
   * Callback de cierre de modal
   **/
  handleClose: PropTypes.func,
};

const I18nLiveStreamForm = injectIntl(withRouter(LivestreamModalForm));

const RTMPAddLivestreamAction = ({ intl, ...props }) => {
  return (
    <Restricted permissions={[permissions.event_manage]}>
      <DataGrid>
        <ActionWithModal
          showModalAccept={false}
          showModalClose={false}
          actionButton
          dialogTitle={intl.formatMessage({ id: "app.page.event.form.add.emisionData" })}
          renderDialogContent={dialogProps => <I18nLiveStreamForm {...dialogProps} {...props} />}
          icon="add"
        />
      </DataGrid>
    </Restricted>
  );
};

RTMPAddLivestreamAction.propTypes = {
  /**
   * Id del evento
   **/
  eventId: PropTypes.string,
  /**
   * Callback de éxito
   **/
  onSuccess: PropTypes.func,
  /**
   * Callback de error
   **/
  onError: PropTypes.func,
};

export default injectIntl(RTMPAddLivestreamAction);
